import { useAuth } from '~/composables/useAuth';

export default defineNuxtPlugin(async (nuxtApp) => {
    const { checkAuth, status } = useAuth();

    // On ne lance la vérification que si elle n'a pas déjà été faite
    // (utile pour les navigations côté client).
    if (status.value === 'loading') {
        // On n'utilise pas `await` ici pour ne pas bloquer le rendu de la page.
        // L'interface réagira automatiquement quand le `status` changera.
        checkAuth();
    }
});